import type { RouteRecordRaw } from 'vue-router'

import { routeNames } from './route-names'
// import { MainLayout } from '../layouts'

// import { dynamicRoutes } from '@/router/dynamic-routes.ts'

export default [
  /*{
    path: '/',
    name: routeNames.Home,
    component: MainLayout,
    redirect: '/welcome',
    hidden: false,
    meta: {
      title: 'Trang chủ',
      page: 'home',
    },
    children: [
      {
        hidden: true,
        path: '/welcome',
        name: routeNames.Welcome,
        component: () => import('@/views/Welcome.vue'),
        meta: {
          title: 'Chào mừng',
          page: 'welcome',
        },
      },
      ...dynamicRoutes,
    ],
  },*/
  {
    path: '/login',
    name: routeNames.Login,
    component: () => import('@/views/auth/Login.vue'),
  },
  {
    path: '/401',
    name: routeNames.Error401,
    component: () => import('@/views/exception/401.vue'),
  },
  {
    path: '/403',
    name: routeNames.Error403,
    component: () => import('@/views/exception/403.vue'),
  },
  {
    path: '/:pathMatch(.*)',
    meta: {
      title: 'Lỗi',
    },
    component: () => import('@/views/exception/error.vue'),
  },
] as RouteRecordRaw[]
